import { ApolloProvider } from '@apollo/client'
import { MsalProvider } from '@azure/msal-react'
import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import { client } from './lib/apollo'
import { SignalRProvider } from './lib/signalR'
import { msalInstance } from './utils/authentication'

import './defaults.css'

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <SignalRProvider>
        <ApolloProvider client={client}>
          <App />
        </ApolloProvider>
      </SignalRProvider>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
